// extracted by mini-css-extract-plugin
export var blockList = "blockList-module--block-list--bJ+NC";